(function () {
    let lastScrollTop = 0;
    let scrollThreshold = 100;
    let isScrolling;
    let isFirstHide = true;

    const headerWrapper = document.querySelector('.header-sticky-wrapper');
    const wrapper = document.querySelector('#HeaderWrapper');
    const siteHeader = document.getElementById('SiteHeader');
    const mobileNav = document.getElementById('MobileNavSticky');

    if (!headerWrapper || !siteHeader) return;

    const isScrollableSticky = siteHeader.getAttribute('data-scrollable-sticky') === 'true';
    const hasOverlay = siteHeader.getAttribute('data-overlay') === 'true';
    const isCollectionTemplate = document.body.classList.contains('template-collection');

    if (!isScrollableSticky) return;

    // Initialize
    headerWrapper.classList.add('header-scroll-init');

    if (isCollectionTemplate) {
        headerWrapper.classList.add('header-collection-mode');
        if (wrapper) wrapper.classList.remove('is-light');
    }

    if (mobileNav) {
        mobileNav.classList.add('mobile-nav-hidden');
    }

    function handleScroll() {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        const isDesktop = window.innerWidth > 768;

        if (Math.abs(currentScroll - lastScrollTop) < 8) return;

        if (currentScroll > scrollThreshold) {
            if (isDesktop) {
                // DESKTOP - Always show header (sticky behavior)
                headerWrapper.classList.remove('header-hidden');
                headerWrapper.classList.add('header-visible');
                siteHeader.classList.add('site-header--opening', 'site-header--stuck');

                if (wrapper) wrapper.classList.remove('is-light');
            } else {
                // MOBILE - Hide/show based on scroll direction
                if (currentScroll > lastScrollTop) {
                    // SCROLLING DOWN - Hide header on mobile

                    if (isFirstHide) {
                        // First time hiding - use no-transition class to hide instantly
                        isFirstHide = false;
                        headerWrapper.classList.add('header-no-transition');
                        headerWrapper.classList.add('header-hidden');
                        headerWrapper.classList.remove('header-visible');
                        siteHeader.classList.remove('site-header--opening', 'site-header--stuck');

                        // Remove no-transition after browser has applied hidden state
                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                headerWrapper.classList.remove('header-no-transition');
                            });
                        });
                    } else {
                        // Subsequent hides - use normal transition
                        headerWrapper.classList.add('header-hidden');
                        headerWrapper.classList.remove('header-visible');
                        siteHeader.classList.remove('site-header--opening', 'site-header--stuck');
                    }

                    if (wrapper) wrapper.classList.remove('is-light');

                    if (mobileNav) {
                        mobileNav.classList.remove('mobile-nav-hidden');
                        mobileNav.classList.add('mobile-nav-visible');
                    }
                } else {
                    // SCROLLING UP - Show header on mobile
                    headerWrapper.classList.remove('header-hidden');
                    headerWrapper.classList.add('header-visible');
                    siteHeader.classList.add('site-header--opening', 'site-header--stuck');

                    if (wrapper) wrapper.classList.remove('is-light');

                    if (mobileNav) {
                        mobileNav.classList.add('mobile-nav-hidden');
                        mobileNav.classList.remove('mobile-nav-visible');
                    }
                }
            }
        } else {
            // AT TOP - Reset
            isFirstHide = true;
            headerWrapper.classList.remove('header-hidden', 'header-visible', 'header-no-transition');
            siteHeader.classList.remove('site-header--opening', 'site-header--stuck');

            if (hasOverlay && wrapper && !isCollectionTemplate) {
                wrapper.classList.add('is-light');
            }

            if (mobileNav) {
                mobileNav.classList.add('mobile-nav-hidden');
                mobileNav.classList.remove('mobile-nav-visible');
            }
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }

    window.addEventListener('scroll', function () {
        if (isScrolling) window.cancelAnimationFrame(isScrolling);
        isScrolling = window.requestAnimationFrame(handleScroll);
    }, { passive: true });

    // Handle window resize to adjust behavior
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            // Trigger scroll handler to apply correct state after resize
            handleScroll();
        }, 250);
    }, { passive: true });
})();